import { Component } from '@angular/core';
import { NavController, NavParams,ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';

import { GlobalProvider } from "../../providers/global/global";
import { ConectorProvider } from "../../providers/conector/conector";


@Component({
  selector: 'page-perfil',
  templateUrl: 'perfil.html',
})
export class PerfilPage {
  data: any = {};
  formulario:any;

  logueado:any 
  usuario:any


  constructor(public navCtrl: NavController, public navParams: NavParams,public global: GlobalProvider,public formBuilder: FormBuilder, public conector:ConectorProvider,private toastCtrl: ToastController) {

        
    this.data = {
      "background"      : "assets/images/background/39.jpg", 
   };

    this.logueado=this.global.LOGGED
    this.usuario=this.global.DATAUSER

    this.formulario = formBuilder.group({
      clave: [''],
      clave2: ['']
    });


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PerfilPage');
    
   
  }

  cambiarclave(){
    console.log("bt cambiarclave")
    console.log(this.formulario)
    if( this.formulario.controls.clave.value == this.formulario.controls.clave2.value ){
      this.conector.CambiarClave(this.formulario.controls.clave.value).subscribe(data => {
     console.log("respuesta guardar solicitud",data)

     let toast = this.toastCtrl.create({
      message: 'Contraseña cambiada con éxito',
      duration: 2000,
      position: 'middle'
    });

    toast.present();

    this.formulario.controls["clave"].setValue("")
    this.formulario.controls["clave2"].setValue("")

    })
  
    } else {
      // toast error claves no iguales
      console.log("no coinciden las claves",this.formulario.controls.clave.value,this.formulario.controls.clave2.value)

      let toast = this.toastCtrl.create({
        message: 'ERROR: no coinciden las claves, inténtalo de nuevo',
        duration: 2000,
        position: 'middle'
      });

      toast.present();
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/perfil/perfil.ts